"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Heading_1 = __importDefault(require("../../components/Heading"));
const List = ({ label, className, variant = 'primary', children }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [label && ((0, jsx_runtime_1.jsx)(Heading_1.default, { as: "h6", className: "mb-2", color: variant === 'primary' ? 'grey-gray' : 'really-red', children: label })), (0, jsx_runtime_1.jsx)("ul", { className: (0, classnames_1.default)(className), children: children })] }));
};
exports.default = List;
